export const appointmentMoveSteps = ['Datum & Uhrzeit', 'Zusammenfassung', 'Bestätigung'] as const;
